import React from 'react';

import { Control, Tooltip } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

function LinkWithPermissionsComponent({
  permissions,
  disabled,
  children,
  disabledTitle,
  can,
  ...props
}) {
  const { t } = useTranslation();
  const { rules, method = 'oneof' } = permissions;

  const hasPermission = can(rules, { method });
  const isDisabled = !hasPermission || disabled;
  const resolvedDisabledTitle = disabledTitle ?? t('btn.insufficient_permissions.title');

  return (
    <Tooltip
      data-tooltip-content={!hasPermission ? t('btn.insufficient_permissions.title') : null}
    >
      <Control.Link
        disabled={isDisabled}
        disabledTitle={resolvedDisabledTitle}
        {...props}
      >
        {children}
      </Control.Link>
    </Tooltip>
  );
}

LinkWithPermissionsComponent.propTypes = {
  permissions: PropTypes.shape({
    rules: PropTypes.arrayOf(PropTypes.string).isRequired,
    method: PropTypes.oneOf(['oneof', 'allof']),
  }),
  can: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabledTitle: PropTypes.string,
  disabled: PropTypes.bool,
};

LinkWithPermissionsComponent.defaultProps = {
  children: undefined,
  permissions: { rules: [], method: 'oneof' },
  disabledTitle: undefined,
  disabled: false,
};

export const LinkWithPermissions = connect((state) => ({
  can: viewerCan(state),
}))(LinkWithPermissionsComponent);
